<template>
  <div class="nkn-word-map body-container">
    <div class="body-container">
      <div class="common-title" v-html="$t('home.wordmap.title')"></div>
    </div>
    <div class="body-container map-container">
      <div class="map">
        <div class="statistics-text" v-html="nodeDistribution()"></div>
        <div class="statistics-histogram">
          <nkn-node-map :geo-list="this.$store.state.map.geo.list" />
        </div>
      </div>
      <div class="chart">
        <div class="statistics-text" v-html="nodeCountryInfo()"></div>
        <!-- <div class="statistics-histogram">
                    <nkn-node-histogram :geo-summary="this.$store.state.map.geo.summaryFinal"/>
        </div>-->
        <div class="statistics-country">
          <nkn-node-country :geo-summary="this.$store.state.map.geo.summaryFinal" />
        </div>
        <div class="btn-fold" @click="foldList">
          <i v-if="fold" class="glyphicon glyphicon-chevron-down"></i>
          <i v-else class="glyphicon glyphicon-chevron-up"></i>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="wordmap-detail">{{$t("home.wordmap.details")}}</div>
    </div>
  </div>

</template>

<script>
import NknNodeMap from "./plugins/nknNodeMap";
import NknNodeHistogram from "./plugins/nknNodeHistogram";
import NknNodeCountry from "./plugins/nknNodeCountry";

export default {
  data() {
    return {
      fold: true
    };
  },
  components: {
    NknNodeHistogram,
    NknNodeMap,
    NknNodeCountry
  },
  name: "nkn-word-map",
  methods: {
    nodeCountryInfo() {
      return this.$t("home.wordmap.nodeByRegions", {
        count: Object.keys(this.$store.state.map.geo.summaryFinal).length - 3
      });
    },
    nodeDistribution() {
      if (0 === this.$store.state.map.geo.commNodePercent) {
        return "";
      }
      return this.$t("home.wordmap.nodeDistribution", {
        total: this.$store.state.map.geo.totalNodeCount,
        team: nknNodeCount,
        community: this.$store.state.map.geo.commNodePercent
      });
    },
    foldList() {
      let nodeCountry = document.querySelector(".statistics-country");
      if (this.fold) {
        nodeCountry.style.maxHeight = "1600px";
        this.fold = !this.fold;
      } else {
        nodeCountry.style.maxHeight = "360px";
        this.fold = !this.fold;
      }
    }
  }
};
</script>

<style scoped>
.nkn-word-map {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  overflow: hidden;
}
.btn-fold {
  display: none;
  text-align: center;
  margin-bottom: 10px;
  color: #44abf5;
}
.glyphicon {
  font-size: 20px;
}
.nkn-word-map > .body-container {
  padding: 0;
}

.nkn-word-map > .body-container > .common-title {
  margin-top: 40px;
  margin-bottom: 40px;
}

.body-container > img {
  width: 100%;
}
.map-container{
  display: flex; flex-wrap: wrap; flex-direction: row; flex-grow: 1;
}
.nkn-word-map > .body-container > .map {
   flex-shrink: 1; flex-grow: 1;
}

.nkn-word-map > .body-container > .chart {
  flex-shrink: 1;
  min-width: 300px;
  width: 300px;
  overflow: hidden;
  margin-left: 10px;
}

.nkn-word-map > .body-container > .map > .statistics-text {
  margin-bottom: 15px;
}

.nkn-word-map > .body-container > .chart > .statistics-text {
  /* padding-left: 36px; */
  margin-bottom: 6px;
  /*font-weight: 600;*/
  /*color: #253a7e;*/
}
.nkn-word-map > .body-container > .chart > .statistics-histogram {
  height: 480px;
  overflow: scroll;
}
.nkn-word-map > .body-container > .chart > .statistics-histogram::-webkit-scrollbar {
  width: 0;
}
.nkn-word-map > .body-container > .chart > .statistics-histogram > div {
  margin-top: -45px;
}
.nkn-word-map > .body-container > .chart > .statistics-country {
  height: 400px;
  overflow: scroll;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.nkn-word-map > .body-container > .chart::-webkit-scrollbar {
  width: 0;
}
.wordmap-detail {
  margin: 10px 0 0 0;
}
@media screen and (max-width: 768px) {
  .nkn-word-map {
    width: 100%;
    margin: 0 auto;
    padding: 20px;
    height: auto;
  }
  .wordmap-detail {
    margin: 0;
  }
  .btn-fold {
    display: block;
  }
  .nkn-word-map > .body-container > .chart > .statistics-histogram {
    display: none;
  }
  .nkn-word-map > .body-container > .chart {
    margin: 0;
  }
  .nkn-word-map > .body-container > .chart > .statistics-country {
    margin: 10px 0 3px 0;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    height: auto;
    max-height: 360px;
    transition: max-height 2s;
    overflow: hidden;
  }
  .nkn-word-map > .body-container > .common-title {
    margin: 0;
    padding-top: 0;
    margin-bottom: 20px;
  }
  .body-container > img {
    width: 100%;
  }
  .nkn-word-map > .body-container > .map {
    position: relative;
    margin-left: 0;
    float: none;
    width: 100%;
    margin-bottom: 20px;
  }

  .nkn-word-map > .body-container > .chart {
    float: none;
    width: 100%;
    height: auto;
    margin-top: 20px;
  }
  .nkn-word-map > .body-container > .chart > .statistics-text {
    padding-left: 0;
    font-size: 12px;
    margin-bottom: 0;
    margin-top: 10px;
  }

  .nkn-word-map > .body-container > .chart > .statistics-histogram {
    height: auto;
  }
}
</style>

<style>
.nkn-word-map > .body-container > .chart > .statistics-text a {
  text-decoration: underline;
  color: #44abf5;
  font-size: 12px;
}

.nkn-word-map > .body-container > .map > .statistics-text .full-node-title {
  font-size: 16px;
}

.nkn-word-map > .body-container > .map > .statistics-text .full-node-count {
  font-size: 22px;
  font-weight: 600;
  padding-right: 10px;
  color: #44abf5;
}

.nkn-word-map > .body-container > .map > .statistics-text .full-node-team {
  font-size: 12px;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/home/nknWordMap.vue